<template>
	<div class="mask">
		<Container v-show='!showPayCode'>
			<TopBar />
			<div class='paymentPage'>
				<template v-if='desc.virtual_flag!=10'>
					<div class="top">
						<div class="logo">
							<div class="shadow">
								<img src="@/assets/order/paylogo.png">
							</div>
						</div>
						<h2>订单提交成功(Order submitted)</h2>
						<div class="time">
							<b>剩余时间:</b>
							<span>{{remaining.hour}}</span><i>:</i>
							<span>{{remaining.minute}}</span><i>:</i>
							<span>{{remaining.second}}</span>
						</div>
						<p>请您在提交订单后0小时30分内完成支付，否则订单会自动取消<br>Please complete the payment within 0 hours and 30 minutes after submitting the order, or the order will be automatically cancelled</p>
					</div>
				</template>
				<template v-else>
					<h2 class="mergeFree">支付合并发货运费:¥{{desc.pay_fee.toFixed(2)}}</h2>
				</template>
				<div class="mid" v-if='desc'>
					<template v-if='desc.virtual_flag!=10'>
						<div class="orderNo">
							<b>NO:&nbsp;{{$route.query.os}}</b>
							<span>未付款</span>
						</div>
						<div class="info">
							<div class="item">
								<span>订单来源:Myo</span>
								<span>¥{{desc.pay_fee.toFixed(2)}}</span>
							</div>
							<div class="item">
								<span>订单类型:{{desc.catalog=='LRP'?'LRP Template':'Standard'}}</span>
								<span>PV:{{desc.total_pv.toFixed(2)}}</span>
							</div>
							<div class="item">
								<span>联系电话:{{passwordTel}}</span>
								<span v-if='!hideNewCustomerCell'>积分:{{desc.ar_value.toFixed(2)}}</span>
							</div>
						</div>

						<div class="info address" v-if='selectdesc&&selectdesc.code=="501"&&desc'>
							<div class="item">
								<span>收货人:</span>
								<span>{{selectdesc.name}} </span>
							</div>
							<div class="item">
								<span>联系方式:</span>
								<span>{{selectdesc.moblie_phone}}</span>
							</div>
							<div class="item">
								<span>详细地址</span>
								<span>{{selectdesc.province}}{{selectdesc.city}} {{selectdesc.county}} {{selectdesc.town||''}}&nbsp;&nbsp; {{selectdesc.street}}</span>
							</div>
							<div class="item">
								<span></span>
								<span>
									修改地址 ( <b @click="changeAwalysAddress" class="update">选择常用地址</b> / <b @click="changeAddress" class="update">填写其他地址</b> )
								</span>
							</div>
						</div>

						<div class="total">
							共{{productCount}}件商品 合计：¥{{desc.pay_fee.toFixed(2)}}&nbsp;(含运费¥{{desc.delivery_fee.toFixed(2)}})
						</div>
					</template>

					<div class="payList">
						<div class="item" @click="swtichPayChannel(20)">
							<div class="left">
								<img src="@/assets/order/wechat.png">
								<b>微信</b>
							</div>
							<img v-if='payChannel==20' class="right" src="@/assets/order/hook.png">
						</div>
						<div class="item align" @click="swtichPayChannel(1)">
							<div class="left">
								<img src="@/assets/order/alipay.png">
								<b>支付宝</b>

							</div>
							<img v-if='payChannel==1' class="right" src="@/assets/order/hook.png">
						</div>
						<div class="item" @click="swtichPayChannel(4)">
							<div class="left">
								<img src="@/assets/order/manyPay1.png">
								<b>支持支付宝、云闪付扫码支付</b>
							</div>
							<img v-if='payChannel==4' class="right" src="@/assets/order/hook.png">
						</div>
						
						<div class="item" @click="swtichPayChannel(3)">
							<div class="left">
								<img src="@/assets/order/unionpay.png">
								<b>单笔订单超20000元建议使用银联支付</b>

							</div>
							<img v-if='payChannel==3' class="right" src="@/assets/order/hook.png">
						</div>
						<div v-if='doAccount' :class='{invalid:doAccount.val < desc.pay_fee}' class="item" @click="swtichPayChannel(5)">
							<div class="left">
								<img src="@/assets/order/doAccount.png">
								<b>dō惠(余额：￥{{doAccount.val}} <span v-if='doAccount.val < desc.pay_fee'>，余额不足</span>)</b>
							</div>
							<img v-if='payChannel==5' class="right" src="@/assets/order/hook.png">
						</div>

					</div>
				</div>
				<div class="foot">
					<Button size='large' :loading="!IsPay" :disabled='payChannel == 0 || countNum <=0' type="primary" shape="circle" @click="goPay">去支付</Button>
				</div>
			</div>

		</Container>
		<transition name="fade">
			<div v-show='showPayCode' class="qrcode-bg">
				<div class='desc' v-if='desc'>
					<p>请您及时付款，以便订单尽快处理！订单号：{{$route.query.os}}</p>
					<p>Please pay timely! Order number: {{$route.query.os}}</p>
					<br>

					<p>请您在提交订单后尽快完成支付, 否则订单将{{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}后取消。</p>
					<p>Please pay timely, time for payment left: {{remaining.hour}}:{{remaining.minute}}:{{remaining.second}}</p>
					<br>
					<p>应付金额:<b>{{desc.pay_fee.toFixed(2)}}</b>元</p>

					<p>Total:<b>{{desc.pay_fee.toFixed(2)}}</b>Yuan</p>
					<div class="qrcode" id='payQRCode'>
						<img :src='QRImg'>
						<div class="qrcode-desc">

							<template v-if='payChannel==2||payChannel==20'>
								<p>请使用微信扫一扫<b>(Use Wechat to scan)</b></p>
								<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
							</template>
							<template v-if='payChannel==4'>
								<p>请使用支付软件扫一扫<b>(Use software to scan)</b></p>
								<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
							</template>
							<template v-if='payChannel==1'>
								<p>请使用支付宝扫一扫<b>(Use AliPay to scan)</b></p>
								<p>扫描二维码支付<b>(Scan the code to pay)</b></p>
							</template>
						</div>
					</div>
					<div class='p-w-sidebar' :class="{alipay:payChannel==1,jhzf:payChannel==4}">

					</div>
				</div>
				<div class="close">
					<svg width="60" height="60" style='cursor: pointer;' @click='colse'>
						<circle cx="30" cy="30" r="25" stroke="#636363" stroke-width="2" fill="none" />
						<line x1="22" y1="38" x2="38" y2="22" style="stroke:#636363;stroke-width:2" />
						<line x1="22" y1="22" x2="38" y2="38" style="stroke:#636363;stroke-width:2" />
					</svg>
				</div>
			</div>
		</transition>
		<addressList ref="addresslist" @confirmaddress='confirmaddress' @chooseAddress='chooseAddress'></addressList>
		<editAddressView title='修改收货人' :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='addressLoading'></editAddressView>
	</div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { api_methods } from "@/service/loadData";
import addressList from "@/components/order/addressList";
import editAddressView from "@/components/order/editAddressView";
import { QRCode } from "@/assets/js/qrcode.js";
import { baseUrl, cdoUrl } from "@/config/env";
import { pc_pv_threshold } from '@/common/constant'
export default {
	data() {
		return {
			payChannel: 20, // 1:支付宝 2、20:微信 3:银联支付
			auto: false,
			result: false,
			IsPay: false,
			countNum: 0,

			desc: null,
			list: null,
			selectdesc: null,
			showPayCode: false,
			order_no: null,
			ajaxpay: null,
			forTime: [5000, 3000],
			forIndex: 0,
			QRImg: null,
			PayIn: false,

			editAddress: {
				id: 0,
				name: null,
				province_id: null,
				moblie_phone: null,
				city_id: null,
				county_id: null,
				town_id: null,
				street: null,
				zip: null,
				is_default: "0",
				tag_type: "0",
				address_type: "1",
			},
			show: false,
			addressLoading: false,
			doAccount:null,
			caddress: {},
		};
	},
	created() {
		this.$nextTick(function () {
			if (this.$route.query.orderno) {
				this.initData(this.$route.query.orderno, this.$route.query.os);
			}
		});
	},
	beforeDestroy: function () {
		clearInterval(this.timer);
		clearInterval(this.ajaxpay);
	},
	mounted() {},
	watch: {},
	mixins: [],
	components: {
		TopBar,
		addressList,
		editAddressView,
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken", "getVipNo"]),
		...mapState({
			userInfo: (state) => state.common.wechatUserInfo.value,
		}),
		remaining: function () {
			let hour = parseInt(this.countNum / 3600);
			if (hour < 10) {
				hour = "0" + hour;
			}
			let minute = parseInt((this.countNum % 3600) / 60);
			if (minute < 10) {
				minute = "0" + minute;
			}
			let second = parseInt(this.countNum % 60);
			if (second < 10) {
				second = "0" + second;
			}
			return { hour, minute, second };
			//return hour + " : " + minute + " : " + second;
		},
		passwordTel: function () {
			if (
				this.selectdesc.moblie_phone &&
				this.selectdesc.moblie_phone.length >= 11
			) {
				return this.selectdesc.moblie_phone.replace(
					/(\d{3})\d{4}(\d{4})/,
					"$1****$2"
				);
			} else {
				return this.selectdesc.moblie_phone;
			}
		},
		productText: function () {
			if (this.list && this.list.length > 0) {
				return (
					"【doTERRA】" +
					this.list[0].name +
					(this.list[0].specification || "")
				);
			}
			return "暂无信息";
		},
		productCount: function () {
			if (this.list && this.list.length > 0) {
				return this.list.length;
			}
			return 0;
		},
		hideNewCustomerCell(){
			return this.userInfo.binding.first_order_status == 0
		},
	},

	methods: {
		...mapActions([
			"unionPayAction",
			"CheckPoint",
			"CheckAR",
			"CheckCart",
			"getOrderStatusAction",
			"changeOrderAddressAction",
			"postAddAddressAction",
			"getWechatUserInfoAction",
			"checkAccountBalanceAction",
			'getAccountBalanceAction',
		]),
		...mapMutations([
			"SAVE_PAYRECORD",
			"PAY_STATE",
			"SET_ORIGINA",
			"SET_ORDERSTATUS",
			"SAVE_USER_TIME",
			"CHOOSE_ADDRESS",
		]),
		async initData(orderNo, os) {
			let response = await this.getAccountBalanceAction()
			if (response && response.length) {
				this.doAccount = response.filter(item=>item.type == 'DH')[0]
			}
			var yz = await api_methods.getProductOrder(
				this.getAccessToken,
				this.getUserId,
				orderNo,
				this.userInfo.binding.user_id,
				1,
				os
			);
			if (yz && yz.data && yz.response.code == "1") {
				var model = yz.data.value;
				this.desc = model.desc;
				this.list = model.product;
				this.selectdesc = model.delivery;
				if (
					(this.desc.order_status == "UnPay" ||
						this.desc.order_status == "Paying") &&
					this.desc.s > 0
				) {
					this.IsPay = true;
					this.countNum = this.desc.s;
					if (
						this.selectdesc.customer_type.toLowerCase() == "rt" &&
						this.desc.total_pv >= pc_pv_threshold
					) {
						if (this.selectdesc.for_name) {
							this.SET_ORIGINA(10);
						} else {
							this.SET_ORIGINA(1);
						}
					} else {
						this.SET_ORIGINA(0);
					}

					this.remainingTime();
				}
			} else {
				this.$Modal.error({
					title: "错误",
					content: "订单数据获取异常",
					onOk: () => {
						this.$router.push("/home");
					},
				});
			}
		},
		remainingTime() {
			if (this.IsPay) {
				clearInterval(this.timer);
				this.timer = setInterval(() => {
					if (this.countNum <= 0) {
						this.showPayCode = false;
						clearInterval(this.timer);
						this.$Modal.warning({
							title: "超时",
							content: "支付超时",
							onOk: () => {
								this.$router.push("/order/orders");
							},
						});
					} else {
						this.countNum--;
					}
				}, 1000);
			}
		},
		swtichPayChannel(channel){
			if (channel == 5 && this.doAccount.val < this.desc.pay_fee) return
			this.payChannel = channel
		},
		shopCartList() {
			let newArr = new Array();
			Object.values(this.list).forEach((item) => {
				newArr.push({
					id: item.Id,
					name: item.name,
					packing_fee: item.packing_fee,
					price: item.price,
					pt: item.pt,
					pv: item.pv,
					point: item.Point,
					amount: item.amount, //现金支付金额
					ar_value: item.ar_value, //AR支付金额
					num: item.num, //数量(个数)，point支付和 amount支付总计个数
					sku_id: item.sku_id,
					sku: item.sku,
					selected: item.selected,
					spec_code: item.spec_code,
					product_flag: item.product_flag,
				});
			});
			return newArr;
		},
		async changeAwalysAddress() {
			this.$refs.addresslist.open();
		},
		async confirmaddress() {
			this.asyncOK(this.caddress);
			// this.editAddress = {
			// 	id: 0,
			// 	orderNo: this.$route.query.os,
			// 	name: this.caddress.name,
			// 	province_id: parseInt(this.caddress.province_id),
			// 	city_id: parseInt(this.caddress.city_id),
			// 	county_id: parseInt(this.caddress.county_id),
			// 	town_id: parseInt(this.caddress.town_id),
			// 	street: this.caddress.street,
			// 	zip: this.caddress.zip,
			// 	moblie_phone: this.caddress.moblie_phone,
			// 	address_type: 2,
			// 	tag_type: "",
			// 	is_default: false,
			// 	whetherAddress: false,
			// };
			// this.show = true;
		},
		chooseAddress(address) {
			this.CHOOSE_ADDRESS({ address, index: 0 });
			this.caddress = address;
		},
		confirm() {
			this.$router.push("/order/payresult");
		},
		async confrimPay() {
			if (!this.IsPay) {
				return false;
			}
			this.IsPay = false;
			if (!this.desc) {
				this.$Modal.error({
					title: "错误",
					content: "数据获取异常",
				});
				return false;
			}
			// var result = await this.CheckPoint({
			// 	point: this.desc.total_change_point,
			// 	step: 3
			// });
			// if (result) {
			// 	this.$Modal.error({
			// 		title: "错误",
			// 		content: result
			// 	});
			// 	this.IsPay = true;
			// 	return false;
			// }
			// result = await this.CheckAR({ ar: this.desc.ar_value, step: 3 });
			// if (result) {
			// 	this.$Modal.error({
			// 		title: "错误",
			// 		content: result
			// 	});
			// 	this.IsPay = true;
			// 	return false;
			// }

			var msg = await this.checkAccountBalanceAction({
				ar: this.desc.ar_value,
				pt: this.desc.total_change_point,
				ab: this.desc.ab_value,
				step: 3,
				isBegin: true,
			});
			if (msg) {
				this.$Modal.error({
					title: "错误",
					content: msg
				});
				this.IsPay = true;
				return false;
			}

			var ll = this.shopCartList();
			var store_id = null;
			if (this.selectdesc) {
				store_id = this.selectdesc.code || null;
			} else {
				store_id = this.desc.store_id;
			}
			if(this.desc.virtual_flag!=10){
					var result = await this.CheckCart({
					ll,
					store_id,
					orderNo: this.$route.query.os,
					step: 3,
				});
				if (result) {
					this.$Modal.error({
						title: "错误",
						content: result,
					});
					this.IsPay = true;
					return false;
				}
			}
			

			var pc = "SF";
			if (this.payChannel == 20) {
				pc = "Wechat";
			} else if (this.payChannel == 5) {
				pc = 'DH'
			}

			var res = await api_methods.payOrder(
				this.getAccessToken,
				this.getUserId,
				this.$route.query.orderno,
				pc,
				this.$route.query.os
			);

			if (res && res.response && res.response.code == "1") {
				if (res.data.value.code == "1") {
					var obj = res.data.value;
					this.order_no = obj.orderno;
					this.SET_ORDERSTATUS(null);
					this.SAVE_PAYRECORD({
						OrderNo: obj.orderno,
						Amount: obj.amount,
						Body: obj.order_body,
						Openid: obj.openid,
						ARValue: obj.arvalue,
						payChannel: this.payChannel,
					});
					var Amount = Math.round(obj.amount * 100, 2);
					var name = this.selectdesc.for_name;
					if (Amount > 0) {
						Amount = 1; //模拟字符1分钱；
						this.IsPay = true;
						return true;
						// if (this.payWay == 2) {

						// }else {
						//     //信用支付
						//     this.$Modal.error({
						//         title:'支付错误',
						//         content:'功能正在开发中，请选择微信支付'
						//     });
						//     this.IsPay = true;
						//     return false
						//     //this.$router.push('/order/paymentconfirm?type=yes&orderno='+obj.orderno);
						// }

						//this.$router.push('/doTERRA/index.html#/order/paymentconfirm?type=yes&orderno='+obj.orderno);
					} else {
						//直接付款成功
						//直接告诉用户付款完成，不能在这里调用，也不能配置URL，这样存在安全风险。 （需要在    og011 中直接完成）
						this.IsPay = true;
						this.$router.push({
							path: "/order/payresult",
							query: {
								type: "yes",
								orderno: this.$route.query.orderno,
								os: this.$route.query.os,
							},
						});
						return false;
					}
				} else if (res.response.errorCode == "0100") {
					this.$Modal.error({
						title: "错误 (error)",
						content: res.data.value.message,
						loading: true,
						okText: "重新加载",
						onOk: async () => {
							await this.getWechatUserInfoAction();
							this.$Modal.remove();
						},
					});
					this.IsPay = true;
					return false;
				} else {
					this.$Modal.error({
						title: "支付异常",
						content: res.data.value.message,
					});
					this.IsPay = true;
					return false;
				}
			} else {
				this.$Modal.error({
					title: "支付异常",
					content: "支付发生异常,请重新尝试",
				});
				this.IsPay = true;
				return false;
			}
			return true;
		},
		async goPay() {
			let res = await this.confrimPay();
			console.log(res);
			if (!res) return;

			if (this.payChannel == 3) {
				location = `${cdoUrl}/Public/Pay/SF/Pay.aspx?order_no=${this.order_no}&pc_no=${this.getVipNo}`;
			} else if (this.payChannel == 1) {
				location = `${cdoUrl}/Public/Pay/AliPay/AliPagePay.aspx?orderno=${this.order_no}&pc_no=${this.getVipNo}`;
			} else if (this.payChannel == 5) {
				location = `${cdoUrl}/Public/Pay/SF/BalancePay.aspx?orderno=${this.order_no}&pc_no=${this.getVipNo}&channel=WebSite`;
			} else {
				var app = "sftogether";
				if (this.payChannel == 2) {
					app = "sfwechat";
				} else if (this.payChannel == 1) {
					app = "sfalipay";
				} else if (this.payChannel == 20) {
					app = "wechat";
				} else if (this.payChannel ==  5) {
					app = "DH";
				}
				//if(this.payChannel)
				let response = await this.unionPayAction({
					order_no: this.$route.query.orderno,
					orderno_tip: this.$route.query.os,
					pc_no: this.getVipNo,
					app,
				});
				if (response && response.Status == 1 && response.QRCode) {
					let el = document.createElement("div");
					var qrcode = new QRCode(el, {
						text: response.QRCode,
						width: 300,
						height: 300,
						colorDark: "#000000",
						colorLight: "#ffffff",
						correctLevel: QRCode.CorrectLevel.H,
					});

					let desEl = document.getElementById("payQRCode");

					desEl.replaceChild(
						qrcode._el.children[1],
						desEl.firstChild
					);
					desEl.firstChild.style.width = "90%";
					desEl.firstChild.style.margin = "0 auto";

					this.showPayCode = true;
					this.PayIn = true;
					this.beginfor(this.order_no);
				} else if (response && !response.QRCode) {
					var params = {
						charset: response.charset,
						signType: response.signType,
						//"data":this.HTMLDecode(response.data),
						data: response.data,
						sign: response.sign,
						extend: response.extend,
					};
					this.standardPost(response.serverUrl, params);
				} else if (response) {
					this.$Modal.error({
						title: "支付失败",
						content: response.Message,
					});
				} else {
					this.$Modal.error({
						title: "支付失败",
						content: "支付发生异常,请重新尝试",
					});
				}
			}
		},
		colse() {
			this.showPayCode = false;
			clearInterval(this.ajaxpay);
		},
		beginfor(orderNo) {
			var vm = this;
			var s =
				this.forTime[this.forIndex] ||
				this.forTime[this.forTime.length - 1];
			clearInterval(this.ajaxpay);
			this.ajaxpay = setInterval(function () {
				vm.forOrderStatus(orderNo);
			}, s); // 每间隔一秒执行一次
		},
		async forOrderStatus(orderNo) {
			let res = await this.getOrderStatusAction(orderNo);
			console.log("查询支付结果");
			if (res) {
				if (res.PayStatus == "1" && (res.OrderStatuss == "Pay" || res.OrderStatuss == "Confirm")) {
					clearInterval(this.ajaxpay);
					this.SAVE_USER_TIME();
					//this.SET_ORDERSTATUS(res);
					this.$router.push({
						path: "/order/payresult",
						query: {
							type: "yes",
							orderno: this.$route.query.orderno,
							os: this.$route.query.os,
						},
					});
					return
				}
			}
			this.forIndex++;
			this.beginfor(orderNo);
		},
		async changeAddress() {
			var delivery = this.selectdesc;
			this.editAddress = {
				id: 0,
				orderNo: this.$route.query.os,
				name: this.selectdesc.name,
				province_id: parseInt(this.selectdesc.province_id),
				city_id: parseInt(this.selectdesc.city_id),
				county_id: parseInt(this.selectdesc.county_id),
				town_id: parseInt(this.selectdesc.town_id),
				street: this.selectdesc.street,
				zip: this.selectdesc.zip,
				moblie_phone: this.selectdesc.moblie_phone,
				address_type: 2,
				tag_type: "",
				is_default: false,
				whetherAddress: false,
			};
			this.show = true;
		},
		async asyncOK(address) {
			this.addressLoading = true;
			var obj = {
				Id: address.id,
				Name: address.name,
				MobliePhone: address.moblie_phone,
				Province: address.province_id,
				City: address.city_id,
				County: address.county_id,
				Town: address.town_id,
				Street: address.street,
				Zip: address.zip,
				AddressType: address.address_type,
				Tags: address.tag_type,
				IsDefault: address.is_default ? 1 : 0,
				CustomerId: this.userInfo.binding.user_id,
				orderNo: this.$route.query.os,
				Remark: "",
			};
			obj.Street = obj.Street.replace(/[\s\S]/g,ch=>{
				let ascii = ch.charCodeAt();
				if (ascii == 10) return '';
				if (ascii == 13) return '';
				if (ascii == 8203) return '';
				if (ascii == 160) return ' ';
				return ch;
			});
			let response = await this.changeOrderAddressAction(obj);
			if (response > 0) {
				if (address.whetherAddress) {
					await this.postAddAddressAction(obj);
					await this.getWechatUserInfoAction();
				}
				this.$Message.success("地址修改成功");
				this.selectdesc.name = this.caddress.name;
				this.selectdesc.moblie_phone = this.caddress.moblie_phone;
				this.selectdesc.province_id = this.caddress.province_id;
				this.selectdesc.city_id = this.caddress.city_id;
				this.selectdesc.county_id = this.caddress.county_id;
				this.selectdesc.town_id = this.caddress.town_id;
				this.selectdesc.province = this.caddress.province;
				this.selectdesc.city = this.caddress.city;
				this.selectdesc.county = this.caddress.county;
				this.selectdesc.town = this.caddress.town;
				this.selectdesc.street = this.caddress.street;
			} else {
				let message = "";
				if (response == -1) {
					message =
						"订单不存在或者订单已经发货或者已经取消不可以修改";
				} else if (response == -2) {
					message = "订单正在处理中，请稍后修改";
				} else {
					message = "地址修改失败";
				}
				this.$Message.error(message);
			}
			this.show = false;
			this.addressLoading = false;
		},
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.paymentPage {
	width: 70.03vw;
	margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
}
.top {
	text-align: center;
	margin: auto;
	margin-top: 30px;
	.logo {
		margin: auto;
		width: 150px;
		border-radius: 200px;
		box-shadow: 1px 1px 20px #dddddd8c;
		height: 150px;
		text-align: center;
		line-height: 210px;
		img {
			width: 55px;
		}
	}
	h2 {
		color: $green;
		margin-top: 20px;
	}
	.time {
		margin-top: 20px;
		span {
			padding: 5px;
			background-color: $theme-color;
			display: inline-block;
			color: white;
		}
		i {
			font-style: normal;
			@include fontSize($font-size-13);
			margin: 0 5px;
		}
		b {
			font-weight: 500;
			margin-right: 5px;
		}
	}
	p {
		margin-top: 20px;
	}
}
.mid {
	width: 40.03vw;
	margin: auto;
	margin-top: 20px;
	.orderNo {
		border-bottom: 1px solid #dedede;
		height: 30px;
		b {
			float: left;
		}
		span {
			float: right;
			padding: 1px 10px;
			border: 1px solid $theme-color;
			color: $theme-color;
			@include fontSize($font-size-13);
			border-radius: 10px;
		}
	}
	.info {
		border-bottom: 1px solid #dedede;
		.item {
			height: 30px;
			line-height: 30px;
			overflow: hidden;
			span:nth-of-type(2) {
				color: $theme-color;
				float: right;
			}
		}
		&.address {
			span:nth-of-type(2) {
				color: #636363;
				float: right;
			}
			b.update {
				color: $theme-color;
				font-weight: 800;
				cursor: pointer;
			}
		}
	}
	.total {
		margin-top: 10px;
		font-weight: 500;
		margin-bottom: 10px;
	}
	.payList {
		.item {
			cursor: pointer;
			padding: 10px 0;
			//clear: both;
			overflow: hidden;
			border-bottom: 1px solid #dedede;

			.left {
				float: left;
				img {
					width: 50px;
				}
				b {
					padding-left: 10px;
					position: relative;
					top: -15px;
				}
			}
			.right {
				float: right;
				width: 25px;
				margin-top: 10px;
			}
		}
	}
}
.foot {
	margin-top: 20px;
	text-align: center;
	button {
		padding: 0 35px;
	}
}

.qrcode-bg {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: white;
	overflow: scroll;
	z-index: 2000;
	//   overflow: hidden;
	.desc {
		display: block;
		position: absolute;
		top: 30px;
		left: 5%;
		width: 95%;
		overflow: hidden;
		//left: calc(45vw - 150px);
		& > p {
			@include fontSize($font-size-18);
			font-weight: bold;
			color: #636363;
			text-rendering: optimizeSpeed;
			font-style: normal;
			b {
				@include fontSize($font-size-30);
				vertical-align: middle;
				color: #bc86c8;
				margin: 0 10px;
				position: relative;
				top: -5px;
			}
		}
	}
	.qrcode {
		margin-top: 20px;
		display: block;
		// position: absolute;
		width: 300px;
		// height: 300px;
		float: left;
		// top: calc(40vh - 50px);
		// left: calc(50vw - 400px);
		.qrcode-desc {
			width: 100%;
			// height: 58px;
			background-color: #bc86c8;
			line-height: 22px;
			color: white;
			text-align: center;
			font-weight: 700;
			@include fontSize($font-size-15);
			line-height: 27px;
			margin-top: 20px;
			b {
				@include fontSize($font-size-13);
				font-weight: 500;
				// display: block;
			}
		}
	}
	.qrimg {
		width: 90%;
		margin: auto;
	}
	.close {
		position: fixed;
		top: calc(3vh - 0px);
		//left: calc(50vw - 30px);
		right: 30px;
	}
}
.p-w-sidebar {
	float: left;
	width: 379px;
	height: 421px;
	padding-left: 50px;
	// margin-top: -20px;
	background: url(http://cdn.doterra.cn/skin/frontend/rwd/dtr/images/phone-bg.png)
		50px 0 no-repeat;
	&.alipay {
		background: url(../../../assets/order/phone-alipay-bg.png) 50px 0
			no-repeat;
	}
	&.jhzf {
		background: url(../../../assets/order/phone-jhzf-bg.png) 50px 0
			no-repeat;
	}
}
.mergeFree {
	text-align: center;
	@include fontSize($font-size-16);
	color: $theme-color;
}

@media (max-width: 768px){
	.paymentPage{
		width: 90%;
		font-size: 0.5rem;

	}
	.mid{
		width: 100%;
	}
	.qrcode-bg .desc > p{
		b{
			font-size: 0.7rem;
		}
		font-size: 0.5rem;
	}
	.qrcode-bg .close{
		right: 0;
	}
	.qrcode-bg .qrcode .qrcode-desc{
		font-size: 0.55rem;
		b{
			font-size: 0.5rem;
		}
	}
	
}
.invalid {
	filter:grayscale(0.9);
	color:#999;
}

</style>